import React from 'react';
import styles from './styles.module.scss';

interface ProgressBarProps {
  progress: number;
}

/**
 * Barra di progresso del wizard
 */
const ProgressBar: React.FC<ProgressBarProps> = ({ progress }) => {
  return (
    <div className={styles.progressContainer}>
      <div
        className={styles.progressBar}
        style={{ width: `${Math.min(100, Math.max(0, progress))}%` }}
      />
    </div>
  );
};

export default ProgressBar;
